"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModalSidebarButton = void 0;
const util_1 = require("@app/util");
const classnames_1 = __importDefault(require("classnames"));
const react_1 = __importDefault(require("react"));
const icon_1 = require("../../icon");
const text_1 = require("../../text");
require("./modal-sidebar-button.scss");
const ModalSidebarButton = ({ children, selected, style, onClick, ico }) => (react_1.default.createElement("div", { "data-testid": 'modal-sidebar-nav-item', onClick: onClick, className: (0, classnames_1.default)('ds-modal-sidebar-button', { selected }), style: (0, util_1.isDefined)(style) ? style : {} },
    (0, util_1.isDefined)(ico) ? react_1.default.createElement(icon_1.Icon, { ico: ico, size: 'small' }) : null,
    react_1.default.createElement(text_1.Text, { type: 'body-large', weight: selected ? 'bold' : 'medium', color: 'inherit' }, children)));
exports.ModalSidebarButton = ModalSidebarButton;
